import lazyLoad from '@utils/lazyLoad'

const operateRoutes = [
  {
    path: '/operateManagement/homepageConfig', // 首页配置
    exact: true,
    component: lazyLoad(() =>
      import('@views/AppMails/OperateManagement/HomepageConfig')
    ),
    meta: {
      title: '轮播图配置',
      layoutMode: 'empty'
    }
  },
  {
    path: '/operateManagement/homepageConfigEdit', // 首页配置
    exact: true,
    component: lazyLoad(() =>
      import('@views/AppMails/OperateManagement/HomepageConfig/Edit')
    ),
    meta: {
      layoutMode: 'empty'
    }
  }
]

export default operateRoutes
